import { format } from "date-fns";

import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  reportData: {
    status: "idle",
    data: {},
    crops: [],
    error: {},
  },
}

export const fetchReport = createAsyncThunk('report', async (data) => {
    const {token, crop, selectedFromDate, selectedToDate} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const cropURI = encodeURIComponent(crop)
      const fromURI = encodeURIComponent(format(selectedFromDate, "yyyy-MM-dd"))
      const toURI = encodeURIComponent(format(selectedToDate, "yyyy-MM-dd"))
      const url = `/api/v0/data/harvest_report/YILI?crop=${cropURI}&from=${fromURI}&to=${toURI}` 

       const response = await axios.get(url, 
                 { headers })
      return response.data
})

const harvestReportSlice = createSlice({
  name: 'report',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchReport.pending.type]:(state, action) => {
      state.reportData = {
        status: "loading",
        data: {},
        crops: [],
        error: {},
      }
    },
    [fetchReport.fulfilled.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: action.payload,
        crops: action.payload.Crops,
        error: {},
      }
    },
    [fetchReport.rejected.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: {},
        crops: [],
        error: "unauthorized",
      }
    },
  }
})

export default harvestReportSlice.reducer
